const CreateVideo_mutate = `
    mutation createVideo(
      $userUuid: String!,
      $title: String!,
      $content: String!,
      $videoUrl: String,
      $duration: Int,
      $isPublished: Boolean!,
      ) {
      createVideo(
        userUuid: $userUuid,
        title: $title,
        content: $content,
        videoUrl: $videoUrl,
        duration: $duration,
        isPublished: $isPublished,
        ) {
        
        video
        {          
          uuid
          videoId
          userId
          {
            username
          }
          title
          content
          videoUrl
          duration
          isPublished
          commentNo
          likeNo
          shareNo
          createBy
          createDate
          updateDate
          updateBy
        }
      }
    }
`;

const VideoByUuid_query = `query($uuid: String!){
  videoByUuid(uuid: $uuid){
    videoId
    uuid
    userId
    {
      id
      userUuid
      firstName
      lastName
      username
      avatarFileName
      listings
      soldToys
      ratingNo
      ratingCount
      dateJoined    
      isLoggedInUserFollowing
    }    
    title
    content
    videoUrl
    duration
    isPublished
    publishedDate
    commentNo
    likeNo
    shareNo
    isLiked
    isInCollection
    createBy
    createDate
    updateBy
    updateDate
    videoComments{
      uuid
      videoCommentId
      content
      likeNo
      isLiked
      userId{
        username
        avatarFileName
        isLoggedInUserFollowing
      }
      replies{
        uuid
        userId
        {
          username
          avatarFileName
          isLoggedInUserFollowing
        }
        content
        videoCommentId{
          videoCommentId
        }
        likeNo
        isLiked
        createBy
        createDate
        updateDate
        updateBy
      }
      createBy
      createDate
      updateBy
      updateDate
    }
  }  
}`;

const EditVideo_mutate = `
  mutation editVideo(
    $videoUuid: String!
    $title: String!
    $content: String!
    $videoUrl: String
    $duration: Int
    $isPublished: Boolean!
  ) {
    editVideo(
      videoUuid: $videoUuid,
      title: $title,
      content: $content,
      videoUrl: $videoUrl,
      duration: $duration,
      isPublished: $isPublished
    ) {
      video {
        uuid        
        videoId
        userId {
          username
        }
        title
        content
        videoUrl
        duration
        isPublished
        commentNo
        likeNo
        shareNo
        createBy
        createDate
        updateDate
        updateBy
      }
    }
  }
`;

const UpdateVideoStatus_mutate = `
    mutation updateVideoStatus(
      $videoUuid: String!,
      $isPublished: Boolean!,
      ) {
      updateVideoStatus(
        videoUuid: $videoUuid,        
        isPublished: $isPublished) {
        
        video
        {
          createBy
          createDate
          updateDate
          updateBy
          uuid
          videoId
          userId
          {
            username
          }
          title
          content
          isPublished
          videoUrl
          duration
          commentNo
          likeNo
          shareNo
        }
      }
    }
`;

const UpdateVideoShareNo_mutate = `mutation UpdateVideoShareNo(
  $videoUuid: String!) {
    updateVideoShareNo(videoUuid: $videoUuid) 
    {
      video
      {
        createBy
        createDate
        updateDate
        updateBy
        uuid
        videoId
        userId
        {
          username
        }
        title
        content
        isPublished
        videoUrl
        duration
        commentNo
        likeNo
        shareNo
      }
    }
  }
`;

const DeleteVideo_mutate = `
    mutation deleteVideo(
      $videoUuid: String!,      
      ) {
      deleteVideo(
        videoUuid: $videoUuid) {
        
         response
      }
    }
`;

const VideosByUserUuid_query = `query($userUuid: String!,$status: String){
  videosByUseruuid(userUuid: $userUuid,status: $status){
    videoId
    uuid    
    title
    content
    duration
    videoUrl
    isPublished
    publishedDate
    commentNo
    shareNo
    likeNo
    isLiked
    isInCollection
    createBy
    createDate
    updateBy
    updateDate
    userId{
      id
      userUuid
      firstName
      lastName
      username
      avatarFileName
      listings
      soldToys
      ratingNo
      ratingCount
      dateJoined
      isLoggedInUserFollowing
    }
    videoLikes{
      videoLikeId
      userId{
        username
        avatarFileName
        isLoggedInUserFollowing
      }
    }
    videoComments{
      uuid
      videoCommentId
      content
      likeNo
      isLiked
      userId{
        username
        avatarFileName
        isLoggedInUserFollowing
      }
      replies{
        uuid
        userId
        {
          username
          avatarFileName
          isLoggedInUserFollowing
        }
        content
        videoCommentId{
          videoCommentId
        }
        likeNo
        isLiked
        createBy
        createDate
        updateDate
        updateBy
      }
      createBy
      createDate
      updateBy
      updateDate
    }
  }  
}`;

const CreateVideoLike_mutate = `
  mutation createVideoLike(
    $videoUuid: String!,     
  ) {
    createVideoLike(
      videoUuid: $videoUuid,        
    ) {        
      videoLike
        {
          uuid
          userId
          {
            id
            username            
          }
          videoId
          {
            videoId
            title           
          }
        }
      }
    }
`;

const DeleteVideoLike_mutate = `
  mutation deleteVideoLike(
    $videoUuid: String!     
  ) {
    deleteVideoLike(
      videoUuid: $videoUuid        
      ) {        
      response
    }
  }
`;

const CreateVideoComment_mutate = `
  mutation createVideoComment(
    $videoUuid: String!,
    $content: String!,     
  ) {
    createVideoComment(
      videoUuid: $videoUuid,
      content: $content,         
    ) {        
      videoComment
        {
          uuid
          userId
          {
            id
            username
            avatarFileName            
          }
          videoId
          {
            videoId
            title           
          }
          title
          content
          likeNo
          createBy
          createDate
          updateBy
          updateDate
        }
      }
    }
`;

const DeleteVideoComment_mutate = `
  mutation deleteVideoComment(
    $videoCommentUuid: String!,      
  ) {
    deleteVideoComment(
      videoCommentUuid: $videoCommentUuid,       
      ) {        
      response
    }
  }
`;

const EditVideoComment_mutate = `
    mutation editVideoComment(
      $videoCommentUuid: String!,
      $content: String!,      
    ) {
      editVideoComment(
        videoCommentUuid: $videoCommentUuid,
        content: $content) {        
        videoComment
        {
          createBy
          createDate
          updateDate
          updateBy
          uuid
          videoCommentId
          userId
          {
            username
          }
          videoId
          {
            uuid
          }
          title
          content          
          likeNo
        }
      }
    }
`;

const AllVideosList_query = `query{
  allVideos{
    videoId
    uuid
    videoUrl
    title
    publishedDate
    isPublished
    createDate
    userId{
      userUuid
      username
    }
  }
}`;

const CreateVideoCommentLike_mutate = `
  mutation createVideoCommentLike(
    $videoCommentUuid: String!,     
  ) {
    createVideoCommentLike(
      videoCommentUuid: $videoCommentUuid,        
    ) {        
      videoCommentLike
        {
          uuid
          userId
          {
            id
            username            
          }
          videoCommentId
          {
            videoCommentId
            title           
          }
        }
      }
    }
`;

const DeleteVideoCommentLike_mutate = `
  mutation deleteVideoCommentLike(
    $videoCommentUuid: String!     
  ) {
    deleteVideoCommentLike(
      videoCommentUuid: $videoCommentUuid        
      ) {        
      response
    }
  }
`;

const CreateVideoCommentReply_mutate = `
  mutation createVideoCommentReply(
    $videoCommentUuid: String!,
    $content: String!,     
  ) {
    createVideoCommentReply(
      videoCommentUuid: $videoCommentUuid,
      content: $content,         
    ) {        
      videoCommentReply
        {
          uuid
          userId
          {
            id
            username
            avatarFileName            
          }
          videoCommentId
          {
            videoCommentId
            title
            content           
          }
          content
          likeNo
          createBy
          createDate
          updateBy
          updateDate
        }
      }
    }
`;

const DeleteVideoCommentReply_mutate = `
  mutation deleteVideoCommentReply(
    $videoCommentReplyUuid: String!,      
  ) {
    deleteVideoCommentReply(
      videoCommentReplyUuid: $videoCommentReplyUuid,       
      ) {        
      response
    }
  }
`;

const EditVideoCommentReply_mutate = `
    mutation editVideoCommentReply(
      $videoCommentReplyUuid: String!,
      $content: String!,      
    ) {
      editVideoCommentReply(
        videoCommentReplyUuid: $videoCommentReplyUuid,
        content: $content) {        
        videoCommentReply
        {
          createBy
          createDate
          updateDate
          updateBy
          uuid
          videoCommentReplyId
          userId
          {
            username
          }
          videoCommentId
          {
            uuid
            title
            content
          }
          content          
          likeNo
        }
      }
    }
`;

const CreateVideoCommentReplyLike_mutate = `
  mutation createVideoCommentReplyLike(
    $videoCommentReplyUuid: String!,     
  ) {
    createVideoCommentReplyLike(
      videoCommentReplyUuid: $videoCommentReplyUuid,        
    ) {        
      videoCommentReplyLike
        {
          uuid
          userId
          {
            id
            username            
          }
          videoCommentReplyId
          {
            videoCommentReplyId
            content           
          }
        }
      }
    }
`;

const DeleteVideoCommentReplyLike_mutate = `
  mutation deleteVideoCommentReplyLike(
    $videoCommentReplyUuid: String!     
  ) {
    deleteVideoCommentReplyLike(
      videoCommentReplyUuid: $videoCommentReplyUuid        
      ) {        
      response
    }
  }
`;

module.exports = {
  CREATE_VIDEO_MUTATION: CreateVideo_mutate,
  VIDEO_BY_UUID: VideoByUuid_query,
  EDIT_VIDEO_MUTATION: EditVideo_mutate,
  UPDATE_VIDEO_STATUS: UpdateVideoStatus_mutate,
  UPDATE_VIDEO_SHARE_NO: UpdateVideoShareNo_mutate,
  DELETE_VIDEO: DeleteVideo_mutate,
  VIDEOS_BY_USER_UUID: VideosByUserUuid_query,
  CREATE_VIDEO_LIKE_MUTATION: CreateVideoLike_mutate,
  DELETE_VIDEO_LIKE_MUTATION: DeleteVideoLike_mutate,
  CREATE_VIDEO_COMMENT_MUTATION: CreateVideoComment_mutate,
  DELETE_VIDEO_COMMENT_MUTATION: DeleteVideoComment_mutate,
  EDIT_VIDEO_COMMENT_MUTATION: EditVideoComment_mutate,
  ALL_VIDEOS_LIST: AllVideosList_query,
  CREATE_VIDEO_COMMENT_LIKE_MUTATION: CreateVideoCommentLike_mutate,
  DELETE_VIDEO_COMMENT_LIKE_MUTATION: DeleteVideoCommentLike_mutate,
  CREATE_VIDEO_COMMENT_REPLY_MUTATION: CreateVideoCommentReply_mutate,
  DELETE_VIDEO_COMMENT_REPLY_MUTATION: DeleteVideoCommentReply_mutate,
  EDIT_VIDEO_COMMENT_REPLY_MUTATION: EditVideoCommentReply_mutate,
  CREATE_VIDEO_COMMENT_REPLY_LIKE_MUTATION: CreateVideoCommentReplyLike_mutate,
  DELETE_VIDEO_COMMENT_REPLY_LIKE_MUTATION: DeleteVideoCommentReplyLike_mutate,
};
